import { Fragment } from "react";
import { SKTBaseComponent } from "./SKTBaseComponent";
import { SKTTextField } from "./SKTTextField";

export const SKTPayerField = ({ data }) => {
  return (
    <Fragment>
      <SKTBaseComponent
        label={<strong>Maksajan tiedot</strong>}
      ></SKTBaseComponent>
      <SKTTextField
        label="Etunimi"
        data={data}
        id="iZFirstName"
        placeholder="Matti"
      />
      <SKTTextField
        label="Sukunimi"
        data={data}
        id="iZLastName"
        placeholder="Maksaja"
      />
      <SKTTextField
        label="Sähköpostiosoite"
        data={data}
        id="iZEmail"
        placeholder="matti.maksaja@yritys.fi"
      />
    </Fragment>
  );
};
